import React from 'react';
import { TooltipV2, TooltipV2Props } from '@withjoy/joykit';

interface MaybeTooltipV2Props {
  readonly disabled: boolean;
  readonly children: JSX.Element;
}

export const TooltipV2Wrapper: React.FC<MaybeTooltipV2Props & TooltipV2Props> = props => (!props.disabled ? <TooltipV2 {...props}>{props.children}</TooltipV2> : props.children);
